import {Component, Input, OnInit,EventEmitter, Output} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { AuthService } from '../../../../services/auth.service';
import { FlagService } from '../../../../shared/services/flag.service';
import { FlagType } from '../../../../shared/utils/enums';
import { Router } from '@angular/router';

@Component({
  selector: 'app-components',
  templateUrl: './components.component.html',
  styleUrl: './components.component.scss'
})
export class ComponentsComponent implements OnInit {
  @Input() agenceInscriptionFormControl: FormGroup;
  @Output() onSubmit = new EventEmitter<any>();

  step: number = 1;
  loading = false;
  showPassword: boolean;

  get passwordFormField() {
    return this.agenceInscriptionFormControl.get('password');
  }

  get siretFormField() {
    return this.agenceInscriptionFormControl.get('siret');
  }

  constructor(private authService: AuthService, private flag: FlagService,private router: Router) {

  }

  ngOnInit(): void {
  }

  signupAgency()
  {
    const f = this.agenceInscriptionFormControl;

    // adresseSiege / raisonSociale are disabled and only filled by SIRET validation,
    // so an empty value means the SIRET still needs to be validated.
    if (!f.get('adresseSiege')?.value || !f.get('raisonSociale')?.value) {
      this.flag.displayFlag('Veuillez valider le SIRET de l\'agence.', FlagType.error, 2);
      return;
    }
    if (f.invalid) {
      this.flag.displayFlag('Veuillez compléter tous les champs requis.', FlagType.error, 2);
      return;
    }

    this.loading = true;

    // Maps to the backend OnboardRequest: creates the agency + its AGENCY / AGENCY_USER accounts.
    const body = {
      agency: {
        name: f.get('nomAgence')?.value,
        siret: f.get('siret')?.value,
        address: f.get('adresseSiege')?.value,
        email: f.get('agencyEmail')?.value,
        phone: ''
      },
      dirigeant: {
        // email: f.get('email')?.value, // dirigeant login email -- onboarding now creates a single AGENCY user
        password: f.get('password')?.value,
        firstName: f.get('nomDirigeant')?.value,
        lastName: '',
        phone: '',
        title: ''
      }
    };

    this.authService.onboard(body).subscribe({
      next: (res) => {
        this.loading = false;
        if (res && res.status === 'success') {
          this.flag.displayFlag('Agence créée avec succès. Vous pouvez vous connecter.', FlagType.success, 2);
          this.router.navigate(['/login']);
        }
      },
      error: (e) => {
        this.loading = false;
        const msg = e?.error?.message
          || (e?.status === 409
                ? 'Cette instance a déjà été configurée.'
                : 'Une erreur est survenue lors de la création de l\'agence.');
        this.flag.displayFlag(msg, FlagType.error, 2);
      }
    });
  }

  validateSiret() {
    this.authService.validateSiret(this.agenceInscriptionFormControl.get('siret')?.value).subscribe({
      next: (res) => {
        // scanfacture.fr identity payload: denomination + adresse/code_postal/ville flat fields.
        const raisonSociale = res?.denomination;
        const fullAddress = [res?.adresse, res?.code_postal, res?.ville]
          .filter((part: string) => !!part)
          .join(' ')
          .trim();

        if (!raisonSociale && !fullAddress) {
          this.flag.displayFlag('Le SIRET n\'a pas été trouvé dans l\'API.', FlagType.error, 2);
          this.agenceInscriptionFormControl.get('raisonSociale')?.patchValue('');
          this.agenceInscriptionFormControl.get('adresseSiege')?.patchValue('');
          return;
        }
        if (res?.etat_administratif && res.etat_administratif !== 'A') {
          this.flag.displayFlag('Ce SIRET correspond à un établissement administrativement fermé.', FlagType.error, 2);
        }

        this.agenceInscriptionFormControl.get('raisonSociale')?.patchValue(raisonSociale || '');
        this.agenceInscriptionFormControl.get('adresseSiege')?.patchValue(fullAddress);
      },
      error: () => {
        this.flag.displayFlag('Le SIRET n\'a pas été trouvé dans l\'API.', FlagType.error, 2);
        //clear the inputs of raison sociale and adresseSiege if the siret is invalid
        this.agenceInscriptionFormControl.get('raisonSociale')?.patchValue('');
        this.agenceInscriptionFormControl.get('adresseSiege')?.patchValue('');
      }
    })
  }

}
